import React from 'react';
import { Image } from '@vgn-medien-holding/vgn-fe-components';
import { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';
import { Collection as CollectionScheme } from '@src/lib/graphql/generated';
import { Link } from '../Link/Link';

export interface CollectionProps extends PropsWithClassProps<'wrapper'> {
  collection: CollectionScheme;
}

export const Collection = React.forwardRef<HTMLDivElement, CollectionProps>(({ collection, classProps }, ref) => {
  if (!collection) return;
  const coverEntries = collection?.items_query?.items
    ?.filter((e) => e.__typename === 'Movie' || e.__typename === 'Show')
    ?.filter((e) => e?.backdrop_image?.url || e.cover_image?.url)
    .slice(0, 3);
  const collectionStyle = twMerge(
    'group overflow-hidden w-full aspect-video relative border-0.5 border-primary/0 cursor-pointer hover:border-primary transition-colors duration-150 items-center justify-center rounded-xl text-white',
    classProps?.root,
  );

  return (
    <Link href={'/collections/' + collection.slug} classProps={{ root: twMerge('content-auto', classProps?.wrapper) }}>
      <div ref={ref} className={collectionStyle}>
        <div className="grid size-full grid-cols-[3fr,4fr,3fr] overflow-hidden rounded-xl">
          {coverEntries?.length > 0 &&
            coverEntries.map((entry, index) => (
              <div className="relative size-full" key={entry?.id}>
                <Image
                  src={entry?.backdrop_image?.url || entry?.cover_image?.url}
                  fill
                  copyright=""
                  classProps={{ root: 'object-cover' }}
                  sizes="(min-width: 872px) 18vw, (min-width: 1248) 11vw, 50vw"
                  alt={collection.title + `Bild ${index}`}
                />
              </div>
            ))}
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/100 via-black/80 to-black/100 opacity-60 transition-opacity duration-300 group-hover:opacity-80"></div>
        <div className="hyphenate absolute inset-0 grid place-items-center px-4 text-center font-herokid text-xl font-semibold">
          {collection.title}
        </div>
      </div>
    </Link>
  );
});

Collection.displayName = 'Collection';
